import React from "react";

import SectionTitle from "../../components/SectionTitle";

import shapeImg1 from "../../assets/img/social/social-shape-1.png";

const Social = () => {
  return (
    <div className="social__area social__plr black-bg p-relative z-index">
      <div className="social__shape-1 d-none d-xl-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xxxl-7 col-xxl-8 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              sectionClass="social__section-box pb-60 text-center section-title-fixed-width"
              titleClass="section-title text-white title-anim"
              subTitleClass="section-subtitle section-white-bg title-anim"
              subTitle="Let's Connect"
              Title="Ready to Discuss Your Next Business Project?"
            />
          </div>
        </div>

        {/* Professional Connection Options */}
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="professional-connect text-center">
              {/* Contact Methods */}
              <div className="connect-options d-flex justify-content-center flex-wrap gap-4 mb-50">
                {/* LinkedIn */}
                <a
                  href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="connect-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "15px 25px",
                    background: "rgba(255, 220, 96, 0.1)",
                    border: "2px solid #FFDC60",
                    borderRadius: "50px",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    minWidth: "200px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#FFDC60";
                    e.target.style.color = "#232323";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255, 220, 96, 0.1)";
                    e.target.style.color = "white";
                  }}
                >
                  <i
                    className="fab fa-linkedin"
                    style={{ fontSize: "20px" }}
                  ></i>
                  <span style={{ fontWeight: "600" }}>Connect on LinkedIn</span>
                </a>

                {/* GitHub */}
                <a
                  href="https://github.com/IMshadow8802"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="connect-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "15px 25px",
                    background: "rgba(255, 220, 96, 0.1)",
                    border: "2px solid #FFDC60",
                    borderRadius: "50px",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    minWidth: "200px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#FFDC60";
                    e.target.style.color = "#232323";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255, 220, 96, 0.1)";
                    e.target.style.color = "white";
                  }}
                >
                  <i className="fab fa-github" style={{ fontSize: "20px" }}></i>
                  <span style={{ fontWeight: "600" }}>View My Code</span>
                </a>

                {/* Email */}
                <a
                  href="mailto:ayushmishra7352@gmail.com"
                  className="connect-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "15px 25px",
                    background: "rgba(255, 220, 96, 0.1)",
                    border: "2px solid #FFDC60",
                    borderRadius: "50px",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    minWidth: "200px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#FFDC60";
                    e.target.style.color = "#232323";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255, 220, 96, 0.1)";
                    e.target.style.color = "white";
                  }}
                >
                  <i
                    className="far fa-envelope"
                    style={{ fontSize: "20px" }}
                  ></i>
                  <span style={{ fontWeight: "600" }}>Send Email</span>
                </a>

                {/* Phone */}
                <a
                  href="tel:+918802487352"
                  className="connect-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "15px 25px",
                    background: "rgba(255, 220, 96, 0.1)",
                    border: "2px solid #FFDC60",
                    borderRadius: "50px",
                    color: "white",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    minWidth: "200px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#FFDC60";
                    e.target.style.color = "#232323";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(255, 220, 96, 0.1)";
                    e.target.style.color = "white";
                  }}
                >
                  <i className="far fa-phone" style={{ fontSize: "20px" }}></i>
                  <span style={{ fontWeight: "600" }}>Call Me</span>
                </a>
              </div>

              {/* Call to Action */}
              <div className="connect-cta">
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.8)",
                    fontSize: "1.1rem",
                    marginBottom: "30px",
                    maxWidth: "600px",
                    margin: "0 auto 30px",
                  }}
                >
                  I'm always interested in discussing new projects and
                  opportunities. Whether you need a custom business application
                  or want to streamline your operations, let's connect and
                  explore how I can help.
                </p>

                <a
                  href="/contact"
                  style={{
                    display: "inline-block",
                    padding: "15px 40px",
                    background: "#FFDC60",
                    color: "#232323",
                    textDecoration: "none",
                    borderRadius: "50px",
                    fontWeight: "700",
                    fontSize: "1.1rem",
                    transition: "all 0.3s ease",
                    boxShadow: "0 8px 25px rgba(255, 220, 96, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 12px 35px rgba(255, 220, 96, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 8px 25px rgba(255, 220, 96, 0.3)";
                  }}
                >
                  Start a Project Together
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Social;
